/**
 * Web Push 通知 API サービス
 */

import { apiClient } from '@/api/client'

/** VAPID public key を取得 */
export const getVapidPublicKey = async (): Promise<string> => {
  const res = await apiClient.get<{ public_key: string }>('/push/vapid-public-key')
  return res.data.public_key
}

/** サブスクリプション登録 */
export const subscribePush = async (subscription: PushSubscription): Promise<void> => {
  const json = subscription.toJSON()
  await apiClient.post('/push/subscribe', {
    endpoint: json.endpoint,
    keys: {
      p256dh: json.keys?.p256dh,
      auth: json.keys?.auth,
    },
  })
}

/** サブスクリプション解除 */
export const unsubscribePush = async (subscription: PushSubscription): Promise<void> => {
  const json = subscription.toJSON()
  await apiClient.post('/push/unsubscribe', {
    endpoint: json.endpoint,
    keys: {
      p256dh: json.keys?.p256dh,
      auth: json.keys?.auth,
    },
  })
}

/** テスト通知送信 */
export const sendTestNotification = async (): Promise<void> => {
  await apiClient.post('/push/test')
}
